import { useVisit } from '../VisitContext';
import { Button } from '~/shared/components/buttons/Button';
import { ChevronRight } from 'lucide-react';

export function NavigateNextButton({ label = 'Next' }: { label?: string }) {
	const { navigateToNextItem } = useVisit();
	return <Button type="button" appearance="outline" onClick={navigateToNextItem} Icon={ChevronRight} label={label} />;
}
